import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Actividad } from '../../../../../../interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { Translators } from '../../../../../../services/shared/translators.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})
export class DetalleComponent implements OnInit {

  @Input() actividad: Actividad;
  @Input() nombrePais: string;

  idioma: Subscription;

   // Sistema de pestañas
   tabs = [
    { id: 'descripcion', title: 'General' },
    { id: 'documentacion', title: 'Documentación' },
    { id: 'importante', title: '¡Importante!' },
    { id: 'finalizando', title: 'Finalizando' }
  ];
  selectedTab = this.tabs[0].id; // Pestaña inicial

  constructor(
      private translatorService: Translators
  ) { }


  ngOnInit(): void {
  }

}
